import React, { useEffect, useState } from "react"

import { formatSalaryWithComma } from "../../utils/formatSalary"
const TagList = props => {
  const [count, setCount] = useState(0)

  useEffect(() => {
    const value = document.querySelectorAll(".tag")
    setCount(value.length)
  }, [props.search])
  return (
    <>
      {Object.keys(props.config).length > 0 && (
        <div className="tags-list">
          {!!props.text && props.text.length > 0 && (
            <span className="tag">{props.text}</span>
          )}
          {props.config.industry &&
            props.config.industry.length > 0 &&
            !!props.industry &&
            props.config.industry.map(industry => {
              if (industry.id.toString() === props.industry.toString()) {
                return (
                  <span className="tag" key={industry.id}>
                    {industry.name}
                  </span>
                )
              }
              return null
            })}
          {props.experience && (
            <span className="tag">
              {props.experience.min + " - " + props.experience.max + " years"}
            </span>
          )}
          {!!props.country && props.country.toString() !== "0" && (
            <span className="tag">
              {!!props.city &&
                props.city.toString() !== "0" &&
                props.config &&
                props.cityList &&
                props.cityList.map(district => {
                  return (
                    <span key={district.id}>
                      {district.id.toString() === props.city.toString() &&
                        district.district + ", "}
                    </span>
                  )
                })}
              {props.province.toString() !== "0" &&
                props.config &&
                props.provinceList &&
                props.provinceList.map(province => {
                  return (
                    <span key={province.id}>
                      {province.id.toString() === props.province.toString() &&
                        province.name + ", "}
                    </span>
                  )
                })}

              {props.country.toString() !== "0"
                ? props.config.country.map(country => {
                    return (
                      <span key={country.id}>
                        {country.id.toString() ===
                          props.country.id.toString() && country.name}
                      </span>
                    )
                  })
                : ""}
            </span>
          )}
          {props.statusList.length > 1 ? (
            <span className="tag">
              {props.statusList.map((stat, index) => (
                <span key={index}>
                  {props.config.status.map(status => {
                    if (status.id.toString() === stat.toString()) {
                      if (index + 1 === props.statusList.length) {
                        //no comma for the last element
                        return status.status
                      } else {
                        return status.status + ", "
                      }
                    }
                    return null
                  })}
                </span>
              ))}
            </span>
          ) : (
            props.statusList.length === 1 &&
            props?.config?.status?.map(status => {
              if (status.id.toString() === props.statusList.toString()) {
                return <span className="tag">{status.status}</span>
              }
              return null
            })
          )}

          {props.workType.length > 1 ? (
            <span className="tag">
              {props.workType.map((jobt, index) => (
                <span key={jobt.id}>
                  {" "}
                  {props.config.job_type.map(job => {
                    if (job.id.toString() === jobt.toString()) {
                      if (index + 1 === props.workType.length) {
                        return <span key={job.id}> {job.name}</span>
                      } else {
                        return <span key={job.id}> {job.name + ", "}</span>
                      }
                    }
                    return null
                  })}
                </span>
              ))}
            </span>
          ) : (
            props.workType.length === 1 &&
            props?.config?.job_type?.map(job => {
              if (job.id.toString() === props.workType.toString()) {
                return <span className="tag">{job.name}</span>
              }
              return null
            })
          )}
          {(props.maxSalary ||
            (props.minSalary !== props.minSalaryBar && !!props.maxSalary) ||
            props.minSalary !== props.minSalaryBar) && (
            <span className="tag">
              Min:{" "}
              {props.minSalary
                ? formatSalaryWithComma(Number(props.minSalary))
                : "0"}
              {props.maxSalary
                ? " - Max: " + formatSalaryWithComma(Number(props.maxSalary))
                : ""}
            </span>
          )}

          {Object.keys(props.search).length > 0 &&
            props.state.isAuthenticated &&
            props.state.user.company?.id &&
            count > 3 && (
              <button
                onClick={() => props.handleModalHide(2, props.location.search)}
                className="tag btn blue-background no-border "
              >
                Save Search
              </button>
            )}
          {((props.state?.isAuthenticated &&
            Object.keys(props.search).length > 6) ||
            (!props.state?.isAuthenticated &&
              Object.keys(props.search).length > 5)) && (
            <button
              onClick={props.handleResetClick}
              className="tag btn faded-background  no-border "
            >
              Reset
            </button>
          )}
        </div>
      )}
    </>
  )
}

export default TagList
